export default "__VITE_ASSET__B_KQWMj4__"